<template>
    <div style="display: inline-flex">
        <div class="iconfont icon-sy-loading rotate" :style="styleObject" :class="styleClass"></div>
        <div class="text" :style="`--height: ${styleObject.fontSize}`" v-if="text !== null || text !== ''">{{text}}</div>
    </div>
</template>

<script>

    import {Constants} from "../../utils";

    export default {
        name: "Loading",
        props:{
            styleObject: {
                type: Object,
                default: () => {
                    return {
                        fontSize: '32px',
                        color: Constants.redColor
                    }
                }
            },
            styleClass: String,
            text:{
                type: String,
                default: '加载中...'
            }
        }
    }
</script>

<style scoped>
    /** 定义 css 变量 **/
    :root{
        --height: 0px;  /* 文字与 loading 图标的等比高度 */
    }

    .text{
        height: var(--height);
        line-height: var(--height);
        margin-left: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/Loading.vue